import { useWorkspace } from '../../state/workspace.js';
import { AnimatorEditor } from './AnimatorEditor.js';
import { CONTROLLER_EXT } from './controller-doc.js';
import { setControllerTextMode, useControllerTextMode } from './text-mode.js';

/**
 * Shown over the Code tab's text editor while the active tab is a
 * `*.controller.json`: the visual Animator editor, or (in text mode) a button
 * back to it.
 */
export function ControllerOverlay() {
  const active = useWorkspace((s) => s.tabs.at(-1) ?? null);
  const asText = useControllerTextMode((s) => s.paths);
  if (!active || !active.toLowerCase().endsWith(CONTROLLER_EXT)) return null;
  const toggle = (text: boolean) => setControllerTextMode(active, text);
  if (asText.has(active)) {
    return (
      <button type="button" className="anim-chip animator-back" onClick={() => toggle(false)}>
        Animator editor
      </button>
    );
  }
  return (
    <div className="animator-overlay">
      <AnimatorEditor key={active} path={active} onShowText={() => toggle(true)} />
    </div>
  );
}
